import { useState, useMemo, createContext, useEffect } from 'react';

const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [activeMenu, setActiveMenu] = useState(0)
    const [userAuth, setUserAuth] = useState(()=>{
        const userSession = localStorage.getItem("freeliefs_user_auth");
        try{
            return JSON.parse(userSession)
        } catch {
            return null
        }
    });

    useEffect(()=>{
        localStorage.setItem("freeliefs_user_auth", JSON.stringify(userAuth))
    },[userAuth])

    // Memoize to prevent unnecessary re-renders
    const value = useMemo(() => ({
        userAuth,
        setUserAuth,
        activeMenu, setActiveMenu,
    }), [activeMenu, userAuth]);
    
    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
}

export default AuthContext